import { useInstantWinsStore } from '@/stores/instant-wins'
import { isInFuture, isInPast } from '@/utils/date-time-utils'
import type { NavigationGuardNext, RouteLocation } from 'vue-router'
import { useToast } from 'vue-toastification'

/**
 * Route guard that ensures the instant win exists and can be viewed.
 * Populates `to.meta.props` so the routed component receives the draw via props.
 */
export const beforeRouteInstantWinUpdate = async function (
  to: RouteLocation,
  _from: RouteLocation,
  next: NavigationGuardNext
) {
  try {
    const toast = useToast()
    const instantWinCode = to.params.instantWinCode as string | undefined

    if (!instantWinCode) {
      return next({ name: 'not-found' })
    }

    const instantWinsStore = useInstantWinsStore()
    const instantWin = await instantWinsStore.getInstantWin(instantWinCode)

    if (!instantWin) {
      return next({ name: 'not-found' })
    }

    if (isInFuture(instantWin.main_prize.open_at)) {
      toast.error(
        'This Instant Prize is not open yet, please come back after: ' +
          instantWin.main_prize.open_at.toFormat('d/MM/y')
      )
      return next({ name: 'prizes' })
    }

    if (isInPast(instantWin.main_prize.close_at)) {
      toast.error(
        'This Instant Prize is in the past, please try a different Instant Prize Draw'
      )
      return next({ name: 'prizes' })
    }

    to.meta.props = instantWin

    return next()
  } catch (error) {
    console.error('Instant win guard failed:', error)
    return next({ name: 'not-found' })
  }
}
